import React,{useState,useContext,useRef,useEffect,useMemo} from "react";
import { useTranslate } from 'react-redux-multilingual'
import {FormatedPrice,ButtonCommande,BipeurInput} from "@gull"
import { Card } from "react-bootstrap";
import LinePaymentRecordRightForm from './PaymentRightComp/LinePaymentRecordRightForm'
import LineRefund from './PaymentRightComp/LineRefund'
import swal from "sweetalert2";
import axios from 'axios'
import { PeripheriqueContext,IsAuthContext } from '../../../../../app/App';
import { epson_tm_h6000V,epson_tm_h6000VOrder,epson_tm_h6000VOrderPreparation,epson_tm_h6000VPreparation,epson_tm_h6000VSupplementPreparation, epson_tm_h6000VSupplementOrderPreparation, epson_tm_h6000VSupplementOrder, epson_tm_h6000VSupplement} from 'app/imprime';
import { openTiroir } from "app/ouvertureTiroir";
import Ticket from "../../../../../app/views/Pdf/Ticket"
import TicketSupplement from "../../../../../app/views/Pdf/TicketSupplement"
import TicketFacture from "../../../../../app/views/Pdf/TicketFacture"
import TicketFactureSupplement from "../../../../../app/views/Pdf/TicketFactureSupplement";
import { BlobProvider } from '@react-pdf/renderer';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

const PaymentFormRight =  (props) =>{
    const t =useTranslate()
    const btnPdf = useRef('')
    const btnTicketFacture = useRef('')
    const [loading,setLoading]=useState({
        giftprint:false,
        pay:false,
        print:false,
        payprint:false,
        giftprintpdf:false,
        printpdf:false,
        payprintpdf:false,
        commande:false,
        invoice:false,
    })
    const [loadingBipeur,setLoadingBipeur] = useState(false)
    const idsLocalStorage=localStorage.getItem("pos").split(',')
    const { peripheriqueParam } = useContext(PeripheriqueContext)  
    const {authParam} = useContext(IsAuthContext);

    const [ticketPdf,setTicketPdf]=useState({})
    const [totalAchat,setTotalAchat]=useState(0)
    const [totalTgc,setTotalTgc]=useState(false)
    const [giftPdf,setGiftPdf]=useState(false)
    const [showOrderBtn,setShowOrderBtn]=useState(true)
    const [pointsFidelitePdf,setPointsFidelitePdf]=useState({
        total:0,
        acquis:0,
        cashbackTotal:0,
        cashbackAcquis:0,
        mode:null
    }) 
    const [to_prepare,setToPrepare]=useState(0)
    const modulePos = authParam.modules.find(value=>value.name=='pos')

    const [bipeurVal,setBipeurVal]=useState((props.currentTicket.bipeur_number) ? props.currentTicket.bipeur_number : '')
    const [bipeurError,setBipeurError]=useState(false)

    let bipeur_field = modulePos.params?.to_prepare?.params?.bipeur_field
    let bipeur_required = modulePos.params?.to_prepare?.params?.bipeur_required
    let auto_close = modulePos.params?.payments?.params?.auto_close
    let thisShop = authParam.sections.length!=0 && authParam.sections.find(value=>value.id==props.currentTicket.section_id)
    const supplement_list_params = modulePos.params?.article?.params?.supplement_list

    const [relanceCloseModal,setRelanceCloseModal] = useState(false) // Cloture automatique modale payment

    // Cloture automatique modale payment
    useEffect(function () {
        if(relanceCloseModal && auto_close) props.closeModal('onCloseModal')
    }, [relanceCloseModal])

    useEffect(function () {
        //on n'affiche pas le bouton commande client si il y a des articles retourné ou une gift card sur le ticket
        Object.keys(props.currentTicket).length!=0 && props.currentTicket.ticket_detail.find(value=>{  
            if(value.special=='retour' || value.special=='gift_card'){
                setShowOrderBtn(false)
            }
        })

        // On vérifie si il y a des articles à préparer
        if (modulePos.params?.to_prepare?.active && props.currentTicket?.ticket_detail) {
            let to_prepare_total=0
            let not_prepared_ticket_detail = props.currentTicket.ticket_detail.filter((value) => !value.prepared)
            not_prepared_ticket_detail.map((value,index)=>{
                to_prepare_total+=value.to_prepare_qty
            })
            setToPrepare(to_prepare_total)
        }
    }, [])
    
    const finishPayment = async (name) =>{
        if (bipeur_field && bipeur_required && bipeurVal=='') {
            setBipeurError(true)
        }
        else {
            props.setBtnDisabled(true)
            setLoading({...loading,[name]:true})
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0],{
                id:props.cookies.current_ticket,
                close:true,
                ...(bipeur_field && { bipeur_number: bipeurVal })
            }).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{   
                    props.setCurrentTicket(response.data.data)
                    props.setPointsFidelite({
                        total:response.data.total_point_fidelite_client,
                        acquis:response.data.total_point_fidelite_ticket,
                        cashbackTotal:response.data.fidelite_client.valeur_cfp ? response.data.fidelite_client.valeur_cfp : 0,
                        cashbackAcquis:response.data.valeur_cfp_ticket ? response.data.valeur_cfp_ticket : 0,
                        mode:response.data.fidelite_client.mode_fidelite
                    })
                    setLoading({...loading,[name]:false})

                    props.setCookie("last_ticket",props.cookies.current_ticket,{ path: "/", expires: props.expire_date }) 

                    if(name=='payprint'){
                        if (supplement_list_params) epson_tm_h6000VSupplement('print',props.currentTicket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam,response.data.total_point_fidelite_client,response.data.total_point_fidelite_ticket,response.data.fidelite_client.valeur_cfp,response.data.valeur_cfp_ticket,response.data.fidelite_client.mode_fidelite)
                        else epson_tm_h6000V('print',props.currentTicket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam,response.data.total_point_fidelite_client,response.data.total_point_fidelite_ticket,response.data.fidelite_client.valeur_cfp,response.data.valeur_cfp_ticket,response.data.fidelite_client.mode_fidelite)
                        if (to_prepare>0) {
                            let new_ticket_detail = response.data.data.ticket_detail.filter((value) => !value.prepared)
                            response.data.data.ticket_detail = new_ticket_detail
                            if (supplement_list_params) epson_tm_h6000VSupplementPreparation('print',props.currentTicket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam,response.data.total_point_fidelite_client,response.data.total_point_fidelite_ticket,response.data.fidelite_client.valeur_cfp,response.data.valeur_cfp_ticket,response.data.fidelite_client.mode_fidelite)
                            else epson_tm_h6000VPreparation('print',props.currentTicket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam,response.data.total_point_fidelite_client,response.data.total_point_fidelite_ticket,response.data.fidelite_client.valeur_cfp,response.data.valeur_cfp_ticket,response.data.fidelite_client.mode_fidelite)
                        }
                        setRelanceCloseModal(true)
                    }else if(name=='pay'){
                        openTiroir(peripheriqueParam,t)
                        setRelanceCloseModal(true)
                    }else if(name=='payprintpdf'){
                        getPdfTicket(response.data.data.bar,'printpdf',true)
                        
                    }
                    props.setBtnDisabled(false)
                    props.setClientFideliteInfo(false)
                    props.setShowBtnFidelite(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading({...loading,[name]:false})
            props.setBtnDisabled(false)
        }
    }

    const getPdfTicket = async (ticketBar,stylePdf,afterFinishPayment) =>{
        setLoading({...loading,[stylePdf]:true})
        if(stylePdf=='giftprintpdf'){ 
            setGiftPdf(true)
        }else{
            setGiftPdf(false)
        }
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/ticket/get_by_reference/"+ticketBar
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{ 
                setTicketPdf(response.data.data)
                setPointsFidelitePdf({
                    total:response.data.total_point_fidelite_client,
                    acquis:response.data.total_point_fidelite_ticket,
                    cashbackTotal:response.data.fidelite_client.valeur_cfp ? response.data.fidelite_client.valeur_cfp : 0,
                    cashbackAcquis:response.data.valeur_cfp_ticket ? response.data.valeur_cfp_ticket : 0,
                    mode:response.data.fidelite_client.mode_fidelite
                })

                var total = 0
                let totaltgc = {}
                response.data.data.ticket_detail.map(item=>{
                    total+=item.prix_remise
                    if(item.tgc!=0){//on exécute pas cette action sur le taux 0
                        if(totaltgc[item.tgc]){
                            //si le taux de tgc existe deja on ajoute le pris du produit au total existant
                            totaltgc={...totaltgc,[item.tgc]:totaltgc[item.tgc]+=item.prix_remise}
                        }else{
                            //Si aucun taux existe on ajoute la taxe 
                            totaltgc={...totaltgc,[item.tgc]:item.prix_remise}
                        }
                        
                    }
                })
                setTotalAchat(total)
                setTotalTgc(totaltgc)

                if(stylePdf=='invoice'){ 
                    setTimeout(()=>{
                        btnTicketFacture.current.click()
                        props.setBtnDisabled(false)
                    },1000)
                }else{
                    setTimeout(()=>{
                        btnPdf.current.click()
                    },1000)
                    if(afterFinishPayment){
                        setTimeout(() => {
                            setRelanceCloseModal(true)
                        }, 1500);
                        setTimeout(() => {
                            setLoading({...loading,payprintpdf:false})
                            props.setBtnDisabled(false)
                        }, 1600);
                    }
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoading({...loading,[stylePdf]:false})
    }

    const addToOrder = async(ticketid,sectionid) => {
        props.setBtnDisabled(true)
        setLoading({...loading,commande:true});
        const response  = await axios.put(process.env.REACT_APP_API_URL+"api/pos/commande/add_more_article/"+ticketid+"/"+sectionid
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{
                setLoading({...loading,commande:false});
                props.setTicketCommande(response.data.data)
                props.setCookie("last_sale_order",response.data.data.id,{ path: "/", expires: props.expire_date }) 
                props.resetSale('salesOrder')
                if (supplement_list_params) epson_tm_h6000VSupplementOrder('print',response.data.data.ticket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam)
                else epson_tm_h6000VOrder('print',response.data.data.ticket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam)
                if (to_prepare>0) {
                    let new_ticket_detail = response.data.data.ticket.ticket_detail.filter((value) => !value.prepared)
                    response.data.data.ticket.ticket_detail = new_ticket_detail
                    if (supplement_list_params) epson_tm_h6000VSupplementOrderPreparation('print',response.data.data.ticket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam)
                    else epson_tm_h6000VOrderPreparation('print',response.data.data.ticket.section_id,response.data.data,t,props.devise,peripheriqueParam,false,authParam)
                }
                props.setBtnDisabled(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        props.setBtnDisabled(false)
    }

    const handleClick = (name) =>{
        switch (name) {
            case 'giftprint':
                if (supplement_list_params) {
                    epson_tm_h6000VSupplement('giftprint',
                        props.currentTicket.section_id,
                        props.currentTicket,
                        t,
                        props.devise,
                        peripheriqueParam,
                        false,
                        authParam,
                        props.pointsFidelite.total,
                        props.pointsFidelite.acquis,
                        props.pointsFidelite.cashbackTotal,
                        props.pointsFidelite.cashbackAcquis,
                        props.pointsFidelite.mode
                    )
                }
                else {
                    epson_tm_h6000V('giftprint',
                        props.currentTicket.section_id,
                        props.currentTicket,
                        t,
                        props.devise,
                        peripheriqueParam,
                        false,
                        authParam,
                        props.pointsFidelite.total,
                        props.pointsFidelite.acquis,
                        props.pointsFidelite.cashbackTotal,
                        props.pointsFidelite.cashbackAcquis,
                        props.pointsFidelite.mode
                    )
                }
            break;
            case 'print':
                if (supplement_list_params) {
                    epson_tm_h6000VSupplement('print',
                        props.currentTicket.section_id,
                        props.currentTicket,
                        t,
                        props.devise,
                        peripheriqueParam,
                        false,
                        authParam,
                        props.pointsFidelite.total,
                        props.pointsFidelite.acquis,
                        props.pointsFidelite.cashbackTotal,
                        props.pointsFidelite.cashbackAcquis,
                        props.pointsFidelite.mode
                    )
                }
                else {
                    epson_tm_h6000V('print',
                        props.currentTicket.section_id,
                        props.currentTicket,
                        t,
                        props.devise,
                        peripheriqueParam,
                        false,
                        authParam,
                        props.pointsFidelite.total,
                        props.pointsFidelite.acquis,
                        props.pointsFidelite.cashbackTotal,
                        props.pointsFidelite.cashbackAcquis,
                        props.pointsFidelite.mode
                    )
                }
                if (to_prepare>0) {
                    let new_ticket_detail = props.currentTicket.ticket_detail.filter((value) => !value.prepared)
                    let new_current_ticket = props.currentTicket
                    new_current_ticket.ticket_detail=new_ticket_detail
                    if (supplement_list_params) {
                        epson_tm_h6000VSupplementPreparation('print',
                            props.currentTicket.section_id,
                            new_current_ticket,
                            t,
                            props.devise,
                            peripheriqueParam,
                            false,
                            authParam,
                            props.pointsFidelite.total,
                            props.pointsFidelite.acquis,
                            props.pointsFidelite.cashbackTotal,
                            props.pointsFidelite.cashbackAcquis,
                            props.pointsFidelite.mode
                        )
                    }
                    else {
                        epson_tm_h6000VPreparation('print',
                            props.currentTicket.section_id,
                            new_current_ticket,
                            t,
                            props.devise,
                            peripheriqueParam,
                            false,
                            authParam,
                            props.pointsFidelite.total,
                            props.pointsFidelite.acquis,
                            props.pointsFidelite.cashbackTotal,
                            props.pointsFidelite.cashbackAcquis,
                            props.pointsFidelite.mode
                        )
                    }                    
                }
            break;
            case 'giftprintpdf':
                getPdfTicket(props.currentTicket.bar,'giftprintpdf',false)
            break;
            case 'printpdf':
                getPdfTicket(props.currentTicket.bar,'printpdf',false)
            break;
            case 'pay':
                finishPayment('pay');
            break;
            case 'payprint':
                finishPayment('payprint');
            break;
            case 'payprintpdf':
                finishPayment('payprintpdf');
            break;
            case 'order':
                props.setOrderForm(true);
                props.setModalTitle(t('salesOrder'))
            break;
            case 'addToOrder':
                addToOrder(props.currentTicket.id,props.posid)
            break;
            case 'invoice':
                props.setBtnDisabled(true)
                getPdfTicket(props.currentTicket.bar,'invoice',false)
            break;
            case 'devis':
                props.setShowDevisPrint(true)
                props.setBtnDisabled(true)
                props.setModalTitle(t('quotation'))
            break;
        }
    }

    const tgcForTicketPdf = useMemo(()=>{
        let result={}
        Object.entries(totalTgc).forEach(([tgcName,montant])=>{
            //fonction qui calcule le montant de tgc à payer par type de tgc
            let coef = +tgcName / 100 + 1
            let totalAmountTgc = (props.digit==0) ? +montant - (Math.round(+montant / +coef)) : Math.round((+montant - (Math.round((+montant / +coef)*100)/100))*100)/100
            result[tgcName] = totalAmountTgc
        })
        return result
    },[totalTgc,props.digit])
    //on calcule le total de tgc payé sur le ticket
    const tgcTotal = useMemo(()=>
        Object.values(tgcForTicketPdf).reduce((sum,value)=>sum+value,0)
    ,[tgcForTicketPdf])

    // Memoized to keep a stable `document` reference across renders that don't actually change the
    // ticket data: BlobProvider regenerates and revokes its blob URL (URL.revokeObjectURL) every
    // time the `document` reference changes (@react-pdf/renderer usePDF, effect on [doc]). Without
    // this memo, opening the PDF in a new tab produced a blob URL that the next render of this
    // component revoked right away: the preview stayed visible (already loaded by the tab) but
    // Chrome's PDF viewer download icon, which re-fetches that blob URL on click, failed
    // ("Vérifiez votre connexion internet").
    const ticketPdfDocument = useMemo(()=>{
        if(Object.keys(ticketPdf).length==0) return false
        return (supplement_list_params) ?
            <TicketSupplement
                ticketPdf={ticketPdf}
                thisShop={thisShop}
                t={t}
                devise={props.devise}
                digit={props.digit}
                totalAchat={totalAchat}
                tgcForTicketPdf={tgcForTicketPdf}
                tgcTotal={tgcTotal}
                giftPdf={giftPdf}
                pointsFidelite={pointsFidelitePdf}
                moduleParam={props.modulePos}
                authParam={authParam}
            />
        :
            <Ticket
                ticketPdf={ticketPdf}
                thisShop={thisShop}
                t={t}
                devise={props.devise}
                digit={props.digit}
                totalAchat={totalAchat}
                tgcForTicketPdf={tgcForTicketPdf}
                tgcTotal={tgcTotal}
                giftPdf={giftPdf}
                pointsFidelite={pointsFidelitePdf}
                moduleParam={props.modulePos}
                authParam={authParam}
            />
    },[ticketPdf,thisShop,props.devise,props.digit,totalAchat,tgcForTicketPdf,tgcTotal,giftPdf,pointsFidelitePdf,props.modulePos,authParam,supplement_list_params])

    const ticketFactureDocument = useMemo(()=>{
        if(Object.keys(ticketPdf).length==0 || !thisShop) return false
        return (supplement_list_params) ?
            <TicketFactureSupplement
                t={t}
                documentType='billing'
                companyInfos={thisShop}
                authParam={authParam}
                ticketFacture={ticketPdf}
                totalTgc={tgcTotal}
                totalAchat={totalAchat}
                tgcForTicketPdf={tgcForTicketPdf}
                devise={props.devise}
                pointsFidelite={pointsFidelitePdf}
                moduleParam={props.modulePos}
            />
        :
            <TicketFacture
                t={t}
                documentType='billing'
                companyInfos={thisShop}
                authParam={authParam}
                ticketFacture={ticketPdf}
                totalTgc={tgcTotal}
                totalAchat={totalAchat}
                tgcForTicketPdf={tgcForTicketPdf}
                devise={props.devise}
                pointsFidelite={pointsFidelitePdf}
                moduleParam={props.modulePos}
            />
    },[ticketPdf,thisShop,props.devise,totalAchat,tgcForTicketPdf,tgcTotal,pointsFidelitePdf,props.modulePos,authParam,supplement_list_params])

    const editBipeurNumber = async () =>{
        setLoadingBipeur(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0],{
            id:props.cookies.current_ticket,
            bipeur_number: bipeurVal
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                props.setCurrentTicket(response.data.data)
                props.setCookie("last_ticket",props.cookies.current_ticket,{ path: "/", expires: props.expire_date }) 
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoadingBipeur(false)
    }

    return(
        <>
            <BlobProvider document={ticketPdfDocument}>
                {({ url }) => (
                    <a ref={btnPdf} className="d-none" href={url} target="_blank">Print</a>
                )}
            </BlobProvider>
            <BlobProvider document={ticketFactureDocument}>
                {({ url }) => (
                    <a ref={btnTicketFacture} className="d-none" href={url} target="_blank">Print</a>
                )}
            </BlobProvider>
            <Card id={props.id}>
                <Card.Header className="text-end">
                    {<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} />}
                </Card.Header>
                <Card.Body className='scrollPayRight'>
                    <strong className="textTotalPosition">Total :</strong>

                    <div className="bodyPaymentDue">
                        {Object.keys(props.currentTicket).length!= 0 &&
                            props.currentTicket.remboursement_records.length!=0 ?
                            props.currentTicket.remboursement_records.map((value,ind)=>{
                                return(
                                    <LineRefund 
                                        key={value.id}
                                        style='row stripeBgRefund stripePadding position-relative'
                                        value={value}
                                        devise={props.devise}
                                        digit={props.digit}
                                        setCurrentTicket={props.setCurrentTicket}
                                        currentTicket={props.currentTicket}
                                        cookies={props.cookies}
                                        posid={props.posid}
                                        restrictionRemoveLinePayment={props.restrictionRemoveLinePayment}
                                        setRestrictionRemoveLinePayment={props.setRestrictionRemoveLinePayment}
                                        section={props.section}
                                    />
                                )
                            })
                        :
                            false
                        }
                        {Object.keys(props.currentTicket).length!= 0 &&
                            props.currentTicket.paiement_records.length!=0 ?
                                props.currentTicket.paiement_records.map((value,ind)=>{
                                    let style = (ind%2 == 0) ? 'row stripeBg stripePadding position-relative' : 'row stripePadding position-relative';
                                    return(
                                        <LinePaymentRecordRightForm 
                                            key={value.id}
                                            style={style}
                                            value={value}
                                            devise={props.devise}
                                            digit={props.digit}
                                            setCurrentTicket={props.setCurrentTicket}
                                            cookies={props.cookies}
                                            posid={props.posid}
                                            restrictionRemoveLinePayment={props.restrictionRemoveLinePayment}
                                            setRestrictionRemoveLinePayment={props.setRestrictionRemoveLinePayment}
                                            section={props.section}
                                            peripheriqueParam={peripheriqueParam}
                                            currentTicket={props.currentTicket}
                                            setClientFideliteInfo={props.setClientFideliteInfo}
                                            setMonnaieRendu={props.setMonnaieRendu}
                                            valueDue={props.valueDue}
                                        />
                                    )
                                })
                            :
                                false
                        }
                    </div>

                    <strong className="textDuePosition">{t('due')}</strong>
                </Card.Body>
                <Card.Footer className="text-end">
                    <FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.valueDue} />
                </Card.Footer>
            </Card>
            {(bipeur_field) &&
                <BipeurInput
                    bipeurVal={bipeurVal}
                    setBipeurVal={setBipeurVal}
                    error={bipeurError}
                    setError={setBipeurError}
                    showButton={(props.currentTicket.status==1 || props.currentTicket.commande!=null) ? true : false}
                    bipeur_field={bipeur_field}
                    bipeur_required={bipeur_required}
                    loading={loadingBipeur}
                    editBipeurNumber={editBipeurNumber}
                    isFor={'payment'}
                />
            }
            <div className="row mt-3">
                {(props.currentTicket.commande!=null) ? 
                    <span className="mt-3 mb-2">{t('salesOrder')+' : '}<strong>{props.currentTicket.commande.bar}</strong></span>
                : 
                    (props.currentTicket.devis!=null) ? 
                        <span className="mt-3 mb-2">{t('quotation')+' : '}<strong>{props.currentTicket.devis.bar}</strong></span>
                    : 
                        false
                }
                <div className="col text-end mt-4 m-0 p-0">
                    {(props.currentTicket.status==1) ? 
                        <>
                            <button ref={props.padsRefs.current.giftPrint} className="btn btn-sm btn-warning" onClick={()=>handleClick('giftprint')}>{(loading.giftprint) ? <div className="spinner-border spinner-border-sm"></div> : t('btnGiftPrint')}</button>&nbsp;&nbsp;
                            <button className="btn btn-sm btn-warning" onClick={()=>handleClick('giftprintpdf')}>{(loading.giftprintpdf) ? <div className="spinner-border spinner-border-sm"></div> : <FontAwesomeIcon icon={faFilePdf} className='fs-5' />}</button>&nbsp;&nbsp;

                            <button ref={props.padsRefs.current.print} className="btn btn-sm btn-primary" onClick={()=>handleClick('print')}>{(loading.print) ? <div className="spinner-border spinner-border-sm"></div> : t('ticket')}</button>&nbsp;&nbsp;
                            <button className="btn btn-sm btn-primary" onClick={()=>handleClick('printpdf')}>{(loading.printpdf) ? <div className="spinner-border spinner-border-sm"></div> : <FontAwesomeIcon icon={faFilePdf} className='fs-5' />}</button>&nbsp;&nbsp;
                            <button className="btn btn-sm btn-primary" onClick={()=>handleClick('invoice')}>{(loading.invoice) ? <div className="spinner-border spinner-border-sm"></div> : t('billing')+' A4'}</button>
                        </>
                    :
                        <>
                            <button ref={props.padsRefs.current.pay} disabled={props.btnDisabled} className="btn btn-success" onClick={()=>handleClick('pay')}>{(loading.pay) ? <div className="spinner-border spinner-border-sm"></div> : t('btnPay')}</button>&nbsp;&nbsp;
                            {(peripheriqueParam && (peripheriqueParam.imprimante_ticket || peripheriqueParam.imprimante_ticket_preparation) ) ? 
                                <>
                                    <button ref={props.padsRefs.current.payPrint} disabled={props.btnDisabled} className="btn btn-info" onClick={()=>handleClick('payprint')}>{(loading.payprint) ? <div className="spinner-border spinner-border-sm"></div> : t('btnPayPrint')}</button>&nbsp;&nbsp;
                                </>
                            : 
                                <>
                                    <button ref={props.padsRefs.current.payPrint} disabled={props.btnDisabled} className="btn btn-info" onClick={()=>handleClick('payprintpdf')}>{(loading.payprintpdf) ? <div className="spinner-border spinner-border-sm"></div> : t('btnPayPrint')}&nbsp;<FontAwesomeIcon icon={faFilePdf} className='fs-5' /></button>&nbsp;&nbsp;
                                </>
                            }
                            <ButtonCommande padsRefs={props.padsRefs} showOrderBtn={showOrderBtn} currentTicket={props.currentTicket} posid={props.posid} btnDisabled={props.btnDisabled} loading={loading} handleClick={handleClick} modulePos={props.modulePos}/>&nbsp;&nbsp;
                            {props.currentTicket.paiement_records && props.currentTicket.paiement_records.length==0 && <button ref={props.padsRefs.current.devis} disabled={props.btnDisabled} className="btn btn-warning" onClick={()=>handleClick('devis')}>{(props.currentTicket.devis!=null) ? t('btnModifier')+' '+t('quotation') : t('quotation')}</button>}
                        </>
                    }
                </div>
            </div>
            
        </>
    )
}

export default PaymentFormRight;